import Marquee from "react-fast-marquee";
import { BRAND } from "../lib/content";

export const EditorialMarquee = ({ speed = 40, gap = "mt-20 md:mt-28" }) => (
  <div className={`relative ${gap} border-y border-ember/40 bg-black py-4 md:py-5`} data-testid="editorial-marquee">
    <Marquee speed={speed} gradient={false} autoFill>
      {Array.from({ length: 6 }).map((_, i) => (
        <span key={i} className="mx-8 inline-flex items-center gap-8 font-gothic text-xl uppercase tracking-[0.15em] text-flame md:text-2xl">
          Journeys Written in Skin
          <img src={BRAND.star} alt="" className="h-5 w-5 opacity-80 md:h-6 md:w-6" />
        </span>
      ))}
    </Marquee>
  </div>
);
